// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('variant.sales', {
    controller: 'SalesController as vm',
    parent: 'variant',
    url: '/sales',
    templateUrl: 'main/article/variant/sales/sales.tpl.html',
    data: { pageTitle: 'Sales' },
  });
};

class SalesController {
  constructor($rootScope, variant) {
    'ngInject';

    this.variant = variant;
    this.article = variant.article;

    $rootScope.pageTitle = `${this.article.itemCode || ''} - Sales`;

    this.nodeGroup = {
      nodeXValues: this.article.nodeXValues,
      nodeYValues: this.article.nodeYValues,
    };
  }
}

angular
  .module('main.article.variant.sales', [])
  .config(config)
  .controller('SalesController', SalesController);
